import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import LoadingSpinner from "../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../constants/ApiConntection";
import MemboticLogo from "../assets/MemboticLogo.png";
import MemboticLogoWhite from "../assets/MemboticLogoWhite.png";
import EmbeddedLoginOrSignUpModal from "./modals/EmbeddedLoginOrSignUpModal";
import PrivacyModal from "./modals/PrivacyModal";
import TermsModal from "./modals/TermsModal";

export default function EmbeddedBooking() {
  const { clubId, activityId, date } = useParams();
  const { user } = useAuthContext();

  const [isLoading, setIsLoading] = useState(true);
  const [profiles, setProfiles] = useState([]);
  const [token, setToken] = useState([]);
  const [event, setEvent] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [bookedProfiles, setBookedProfiles] = useState([]);
  const [noneBookedUsers, setNoneBookedUsers] = useState([]);
  const [confirmBooking, setConfirmBooking] = useState(false);
  const [bookingComplete, setBookingComplete] = useState(false);
  const [requestCancel, setRequestCancel] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [warning, setWarning] = useState("");
  const [isActing, setIsActing] = useState(false);
  const [club, setClub] = useState([]);
  const [privacyModal,setPrivacyModal] = useState(false)
  const [terms,setTerms] = useState(false)

  const cancelModal = () => {
    setPrivacyModal(false)
    setTerms(false)
  }

 

  const toTime = (n) => {
    if (n == null) return null;
    const s = String(n).padStart(4, "0");
    return `${s.slice(0, 2)}:${s.slice(2)}`;
  };
  const toGBP = (p) => (p == null ? null : `£${(p / 100).toFixed(2)}`);

  const selectedBooking = {
    stripeProductId: event?.stripeProductId,
    eventId: activityId,
    date,
    clubId,
    name: event?.name,
    description: event?.description,
    timeIn: toTime(event?.timeIn),
    timeOut: toTime(event?.timeOut),
    price: event?.price,
    fullyBooked: event?.fullyBooked,
  };

  useEffect(() => {
    if (!user) {
      setIsLoading(false);
      return;
    }
    fetchData();
  }, [user]);

  useEffect(() => {
    const booked = profiles.filter((p) => p.isBooked);
    const noneBooked = profiles.filter((p) => !p.isBooked);
    setBookedProfiles(booked);
    setNoneBookedUsers(noneBooked);
  }, [profiles]);

  useEffect(() => {
    if (!date) return;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bookingDate = new Date(date);
    if (bookingDate < today) {
      setWarning(
        `Please note: This class occurred on ${bookingDate.toLocaleDateString()}. Only proceed with booking if you physically attended the session on that date.`
      );
    } else {
      setWarning("");
    }
  }, [date]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${clubId}`
      );

      setClub(clubResponse.data);

      const tokenResponse = await axios.get(
        `${ApiConnectionString}/api/Token/${clubId}/${activityId}`,
        { headers: { Authorization: `bearer ${user.token}` } }
      );
      setToken(tokenResponse.data);

      const profileResponse = await axios.get(
        `${ApiConnectionString}/api/BookingProfilesForEvent?AppUserId=${user.id}&ClubId=${clubId}&EventId=${activityId}&FromDateTime=${date}`,
        { headers: { Authorization: `bearer ${user.token}` } }
      );
      setProfiles(profileResponse.data);

      const eventResposnse = await axios.get(
        `${ApiConnectionString}/api/event/${activityId}`,
        { headers: { Authorization: `bearer ${user.token}` } }
      );
      setEvent(eventResposnse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
      setIsActing(false);
    }
  };

  const handleSelectProfile = (e) => {
    setSelectedProfileId(e.target.value);
  };

  const handleSelectButtonClick = () => {
    const u = noneBookedUsers.find(
      (x) => String(x.id) === String(selectedProfileId)
    );
    setSelectedUser(u || null);
    setConfirmBooking(!!u);
  };

  const handleBookWithSub = async () => {
    if (!selectedUser) return;
    setIsActing(true);
    try {
      const payload = {
        eventId: selectedBooking.eventId,
        bookingProfileId: selectedUser.id,
        date: selectedBooking.date,
      };
      const res = await axios.post(
        `${ApiConnectionString}/api/bookingSubscription`,
        payload,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );
      if (res.status === 200) {
        setBookingComplete(true);
        setConfirmBooking(false);
        setSelectedProfileId("");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsActing(false);
    }
  };

  const handleBookWithTokens = async (productId) => {
    if (!selectedUser) return;
    setIsActing(true);
    try {
      const payload = {
        eventId: selectedBooking.eventId,
        bookingProfileId: selectedUser.id,
        date: selectedBooking.date,
        productId,
      };
      const res = await axios.post(
        `${ApiConnectionString}/api/BookingTokens`,
        payload,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );
      if (res.status === 200) {
        setBookingComplete(true);
        setConfirmBooking(false);
        setSelectedProfileId("");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsActing(false);
    }
  };

  const handleBookAndBuy = async () => {
    if (!selectedUser) return;
    setIsActing(true);
    try {
      const payload = {
        productId: selectedBooking.stripeProductId,
        eventId: selectedBooking.eventId,
        bookingProfileId: selectedUser.id,
        date: selectedBooking.date,
      };
      const res = await axios.post(
        `${ApiConnectionString}/Api/Checkout/BuyAndBook`,
        payload,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (res.status === 200) {
        window.location.href = res.data;
      }
    } catch (e) {
      console.error(e);
      setIsActing(false);
    }
  };

  const handleCancelRequest = async () => {
    if (!selectedProfile) return;
    setIsActing(true);
    try {
      const payload = { id: selectedProfile.bookingId };
      const res = await axios.put(
        `${ApiConnectionString}/api/booking`,
        payload,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (res.status === 200) {
        setRequestCancel(false);
        fetchData();
      }
    } catch (e) {
      console.error(e);
    } finally {
      setIsActing(false);
    }
  };

  if (isLoading) return <LoadingSpinner />;

  const items = [];
  if (event?.name) items.push({ label: "Name", value: event.name });
  if (event?.description)
    items.push({ label: "Description", value: event.description });
  if (event?.day) items.push({ label: "Day", value: event.day });
  const tIn = selectedBooking.timeIn;
  const tOut = selectedBooking.timeOut;
  if (tIn && tOut) items.push({ label: "Time", value: `${tIn} – ${tOut}` });
  const price = toGBP(event?.price);
  if (price) items.push({ label: "Price", value: price });
  return (
    <div>
  <button
  className="floating-back-button"
  onClick={() => window.history.back()}
>
  ← Go Back
</button>
      <div className="bg-white">
        <div className="container">
          <div className="d-flex justify-content-center">
            <Link to="/">
              <img
                src={MemboticLogo}
                className="login-logo"
                alt="Membotic - All your fitness clubs and activities together"
                title="Membotic - All your fitness clubs and activities together"
              />
            </Link>
          </div>
        </div>
      </div>

      <div className="container bg-white rounded-4 shadow-sm p-4 my-4">
        {!user && <EmbeddedLoginOrSignUpModal />}

        {user && (
          <>
            <div className="row align-items-center g-4 mb-4">
              <div className="col-md-8 order-2 order-md-1">
                <h2 className="mb-2">{club.name}</h2>
                <p className="text-muted mb-0">{club.description}</p>
              </div>
              <div className="col-md-4 order-1 order-md-2 text-md-end">
                <img
                  src={`${ApiConnectionString}/api/ClubProfileImage/${club.id}`}
                  alt={club.name}
                  className="img-fluid rounded-3"
                />
              </div>
            </div>

            {bookingComplete ? (
              <div className="text-center">
                <h5 className="mb-3">Booking</h5>
                <p className="mb-3">
                  <strong>{selectedUser?.username}</strong> has been booked into{" "}
                  <strong>{selectedBooking.name}</strong> on{" "}
                  <strong>
                    {new Date(selectedBooking.date).toLocaleDateString()}
                  </strong>{" "}
                  at{" "}
                  <strong>
                    {tIn} – {tOut}
                  </strong>
                  .
                </p>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setBookingComplete(false);
                    fetchData();
                  }}
                >
                  Okay
                </button>
              </div>
            ) : requestCancel ? (
              <div className="p-3 rounded-3 border mb-3">
                <div className="mb-3">
                  <h5 className="mb-1">
                    {selectedProfile?.cancelPending
                      ? "Re book"
                      : "Cancel booking"}
                  </h5>
                  <p className="mb-0">
                    {selectedProfile?.cancelPending
                      ? "Please confirm that you want to request to re book onto this booking"
                      : "Please confirm that you want to request to cancel this booking"}
                  </p>
                </div>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-danger"
                    onClick={handleCancelRequest}
                    disabled={isActing}
                  >
                    Confirm
                  </button>
                  <button
                    className="btn btn-outline-dark"
                    onClick={() => setRequestCancel(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : confirmBooking ? (
              <div className="p-3 rounded-3 border">
                <h5 className="mb-3">Booking</h5>

                <p className="mb-3">
                  You have selected <strong>{selectedUser?.username}</strong> to
                  be booked into <strong>{selectedBooking.name}</strong> from{" "}
                  <strong>
                    {tIn} – {tOut}
                  </strong>{" "}
                  on{" "}
                  <strong>
                    {new Date(selectedBooking.date).toLocaleDateString()}
                  </strong>
                  .
                </p>

                {!selectedUser?.isSubscribed && token.length > 0 && (
                  <>
                    <p className="text-muted">
                      Use a class token to book this class. One token will be
                      deducted.
                    </p>
                    <ul className="list-group mb-3">
                      {token.map((it) => (
                        <li
                          key={it.id}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <div className="fw-bold">{it.viewProduct.name}</div>
                            <div>
                              <span className="text-danger">
                                Classes Amount:
                              </span>{" "}
                              {it.tokenAmount}
                            </div>
                          </div>
                          {it.tokenAmount > 0 && (
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                handleBookWithTokens(it.viewProduct.id)
                              }
                              disabled={isActing}
                            >
                              Book In
                            </button>
                          )}
                        </li>
                      ))}
                    </ul>
                  </>
                )}

                {!selectedUser?.isSubscribed && token.length === 0 && (
                  <div className="alert alert-danger mb-3">
                    {selectedUser?.username} does not have an active
                    subscription or class tokens to book this class.
                  </div>
                )}

                {selectedUser?.isSubscribed && selectedUser?.hasAccess && (
                  <>
                    <p className="fw-bold mb-1">
                      You can book this class using your subscription
                    </p>
                    <p className="text-muted">
                      {selectedUser?.username} has access through the
                      subscription <strong>{selectedUser?.productName}</strong>.
                    </p>
                    <button
                      className="btn btn-primary mb-3 w-100"
                      onClick={handleBookWithSub}
                      disabled={isActing}
                    >
                      Book In
                    </button>
                  </>
                )}

                {selectedUser?.isSubscribed && !selectedUser?.hasAccess && (
                  <>
                    <p className="text-warning">
                      Your subscription does not cover this event. You can use
                      class tokens instead.
                    </p>
                    <p className="text-muted">
                      Use a class token to book this class. One token will be
                      deducted.
                    </p>
                    <ul className="list-group mb-3">
                      {token.map((it) => (
                        <li
                          key={it.id}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <div className="fw-bold">{it.viewProduct.name}</div>
                            <div>
                              <span className="text-danger">
                                Classes Amount:
                              </span>{" "}
                              {it.tokenAmount}
                            </div>
                          </div>
                          {it.tokenAmount > 0 && (
                            <button
                              className="btn btn-primary"
                              onClick={() =>
                                handleBookWithTokens(it.viewProduct.id)
                              }
                              disabled={isActing}
                            >
                              Book In
                            </button>
                          )}
                        </li>
                      ))}
                    </ul>
                  </>
                )}

                {selectedBooking.price && (
                  <p className="text-muted">
                    If you would like to book without a subscription or token,
                    you can purchase for {toGBP(selectedBooking.price)} by
                    clicking{" "}
                    <Link onClick={handleBookAndBuy}>Book and Buy</Link>.
                  </p>
                )}

                <div className="d-flex gap-2">
                  <button
                    className="btn btn-outline-dark"
                    onClick={() => setConfirmBooking(false)}
                    disabled={isActing}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div className="mb-4 p-3 bg-light rounded border">
                  <h5 className="mb-2 fw-bold">{selectedBooking.name}</h5>
                  <p className="mb-2 text-muted">
                    {selectedBooking.description}
                  </p>
                  <div className="mb-1">
                    <span className="fw-semibold">Day: </span>
                    {event?.day}
                  </div>
                  <div className="mb-1">
                    <span className="fw-semibold">Time: </span>
                    {tIn} – {tOut}
                  </div>
                  <div>
                    <span className="fw-semibold">Date: </span>
                    {new Date(date).toLocaleDateString()}
                  </div>
                </div>

                {warning && (
                  <div className="alert alert-danger" role="alert">
                    {warning}
                  </div>
                )}

                {bookedProfiles.length > 0 && (
                  <>
                    <h5 className="mb-2">Currently Booked</h5>
                    <ul className="list-group mb-4">
                      {bookedProfiles.map((p) => (
                        <li
                          key={p.id}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <div className="d-flex align-items-center gap-2">
                            <span>{p.username}</span>
                            {p.cancelPending && (
                              <span className="badge bg-danger-subtle text-danger">
                                Cancel Pending
                              </span>
                            )}
                          </div>
                          <div className="btn-group">
                            {!p.cancelPending && (
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => {
                                  setSelectedProfile(p);
                                  setRequestCancel(true);
                                }}
                              >
                                Request Cancel
                              </button>
                            )}
                            {p.cancelPending && (
                              <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => {
                                  setSelectedProfile(p);
                                  setRequestCancel(true);
                                }}
                              >
                                Re Book
                              </button>
                            )}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </>
                )}

                {!selectedBooking.fullyBooked ? (
                  <>
                    <h5 className="mb-2">Select Profile</h5>
                    {noneBookedUsers.length > 0 ? (
                      <>
                        <select
                          className="form-select mb-3"
                          value={selectedProfileId}
                          onChange={handleSelectProfile}
                        >
                          <option value="">Choose a profile...</option>
                          {noneBookedUsers.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.username}
                            </option>
                          ))}
                        </select>
                        <button
                          className="btn btn-primary btn-lg w-100"
                          onClick={handleSelectButtonClick}
                          disabled={selectedProfileId === ""}
                        >
                          Book In
                        </button>
                      </>
                    ) : (
                      <p>All your profiles are booked into this class.</p>
                    )}

                    <p className="text-muted small mt-3 mb-0">
                      To book additional individuals into the same class, you
                      can create a separate profile under{" "}
                      <Link to="/myprofile">My Profiles</Link>.
                    </p>
                  </>
                ) : (
                  <p className="text-danger fw-bold">Fully booked</p>
                )}
              </>
            )}
          </>
        )}
      </div>

      <div className="container-fluid" style={{ backgroundColor: "#12384d" }}>
        <div className="pt-5 mx-5 d-flex justify-content-center">
          <Link
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            to="/"
          >
            <img
              src={MemboticLogoWhite}
              className="logo"
              alt="Membotic - All your fitness clubs and activities together"
              title="Membotic - All your fitness clubs and activities together"
            />
          </Link>
        </div>

        <div className="row">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex link-hover-effect">
              <Link onClick={() => setPrivacyModal(true)}>
                Privacy Policy
              </Link>
              <p className="text-white mx-1 mb-0">|</p>
              <Link onClick={() => setTerms(true)}>
                Terms Of Use
              </Link>
            </div>
            <div className="text-white ms-auto">
              &copy; Membotic {new Date().getFullYear()}
            </div>
          </div>
        </div>
      </div>
      {terms && <TermsModal  cancelModal={cancelModal}/>}
      {privacyModal && <PrivacyModal cancelModal={cancelModal} />}
    </div>
  );
}
